import { render, staticRenderFns } from "./ResetForgotPasswordView.vue?vue&type=template&id=5c3b1753"
import script from "./ResetForgotPasswordView.vue?vue&type=script&lang=ts"
export * from "./ResetForgotPasswordView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports